import {useOrderChangeContext} from '@hconnect/tuc-processes/orderManagement'
import {
  compareLifeCycle,
  LifeCycleEvent
} from '@hconnect/tuc-processes/orderManagement/orderChange/lifeCycle'
import {usePlusLoad} from '@hconnect/tuc-processes/orderManagement/orderChange/plusLoad'
import React from 'react'

import {OrderManagementAfterStartedQuantityStep} from './OrderManagementAfterStartedQuantityStep'
import {OrderManagementBeforeStartedQuantityStep} from './OrderManagementBeforeStartedQuantityStep'
import {OrderManagementPlusLoadQuantityStep} from './OrderManagementPlusLoadQuantityStep'

/**
 * Main wrapper component for OrderManagement quantity step.
 * Selects the appropriate quantity step based on order lifecycle state and plus load feature.
 */
export const OrderManagementQuantityStep: React.FC = () => {
  const {processData: order} = useOrderChangeContext()
  const {isEnabled: isPlusLoadEnabled} = usePlusLoad()

  if (compareLifeCycle(order, LifeCycleEvent.Started) === 'after') {
    return isPlusLoadEnabled ? (
      <OrderManagementPlusLoadQuantityStep />
    ) : (
      <OrderManagementAfterStartedQuantityStep />
    )
  }

  return <OrderManagementBeforeStartedQuantityStep />
}
